<div stack-layout gap="xs">
  <div box-layout paddingHorizontal="sm">
    <Text role="headline-small" color="on-primary-surface-variant">
      {{ label() }}
    </Text>
  </div>
  <div
    box-layout
    border="light"
    borderRadius="xs"
    paddingHorizontal="sm"
    paddingVertical="xxs"
    [minHeight]="26"
  >
    <Text><ng-content></ng-content></Text>
  </div>
</div>
